import React from "react"
import { NavLink } from "react-router-dom"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown, faSignOutAlt, faDice, faRocket, faEnvelope } from "@fortawesome/free-solid-svg-icons"

import { User } from "./../../../CheckLogin"

class AccountDropDown extends React.Component{
    constructor(){
        super()
        this.state = {
            isDropDownOpen: false
        }
        //using refs to check user clicks, and toggle dropdown accordingly
        //ref for the dropdown menu.
        this.dropDownRef = React.createRef();
        //ref for the dropdown toggle. 
        this.toggleRef = React.createRef();
    }
    toggleDropDown = () =>{

        this.setState(prevState => {return {
            isDropDownOpen: !prevState.isDropDownOpen
        }})
    }
    handleClickOutside = (e) =>{
        if (this.state.isDropDownOpen === false){
            return
        }
        if (this.state.isDropDownOpen === true){
            if (e.target.id === "dropDownToggle" || this.toggleRef.current.contains(e.target)) return
            if (this.dropDownRef && !this.dropDownRef.current.contains(e.target)){
                this.setState({isDropDownOpen: false})
            }
        }
        else return
    }
    componentDidMount = () =>{
        document.addEventListener("mousedown", this.handleClickOutside)
    }
    componentWillUnmount = () =>{
        document.removeEventListener("mousedown", this.handleClickOutside)
    }
    render(){
        return(
            <User.Consumer>
                {(user) => (
                    <div className="accountDropDown">
                    <div ref={this.toggleRef} id="dropDownToggle" className={`visible ${this.state.isDropDownOpen? "open" : "closed"}`} onMouseDown={this.toggleDropDown}>
                        <img src="/userPlaceHolder.png" alt="logo" />
                        <FontAwesomeIcon tabIndex="0" icon={faChevronDown} className={`${this.state.isDropDownOpen? "open" : "closed"}`}/>
                    </div>
                    <ul ref={this.dropDownRef} className={`dropDown ${this.state.isDropDownOpen? "open" : "closed"}`}>
                        <li className="userInfo">
                            <div className="name field">{user.displayName}</div>
                            <div className="email field">{user.email}</div>
                        </li>
                        <li className="activities">
                            <NavLink to="/launcher" onClick={this.toggleDropDown}
                                activeClassName="active">
                                <div className="option">
                                    <div className="iconWrapper">
                                        <FontAwesomeIcon icon={faRocket} />
                                    </div>
                                    Download Launcher
                                </div>
                            </NavLink>
                            {user.permissions.includes('EDITOR/CLIENT/DOWNLOAD/RELEASE') && 
                                <NavLink to="/editor_download" onClick={this.toggleDropDown}
                                activeClassName="active">
                                    <div className="option">
                                        <div className="iconWrapper">
                                            <FontAwesomeIcon icon={faRocket} />
                                        </div>
                                        Download Editor
                                    </div>
                                </NavLink>
                            }
                            {user.permissions.includes("ARCADE/MAP/PUBLISH") === false
                            ? null
                            : <NavLink to={{
                                    pathname: "/console/user/" + user.id
                                }} onClick={this.toggleDropDown}
                                activeClassName="active">
                                <div className="option">
                                    <div className="iconWrapper">
                                        <FontAwesomeIcon icon={faDice} />
                                    </div>
                                    I have made...
                                </div>
                            </NavLink>
                            }
                            {user.permissions.includes("ARCADE/MAP/TESTERS/EDIT") === false
                            ? null
                            : <NavLink to={{
                                pathname:"/invite"
                            }} onClick={this.toggleDropDown}
                            activeClassName="active">
                                <div className="option">
                                    <div className="iconWrapper">
                                        <FontAwesomeIcon icon={faEnvelope} />
                                    </div>
                                    Invite my friend!
                                </div>
                            </NavLink>
                            }
                        </li>
                        <li className="logout">
                            <a className="logoutBtn" href="/logout" tabIndex="-1">
                                <FontAwesomeIcon icon={faSignOutAlt} />   Logout
                            </a>
                        </li>
                    </ul>
                </div>
                )}

            </User.Consumer>
        )
    }
}

export default AccountDropDown